import { render, staticRenderFns } from "./EtapaDadosNavio.vue?vue&type=template&id=3c33204d"
import script from "./EtapaDadosNavio.vue?vue&type=script&lang=js"
export * from "./EtapaDadosNavio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports